<template>
    <a-drawer
        :title="$t('web.list' /* 列表 */)"
        width="600"
        placement="right"
        :closable="true"
        :body-style="{ height: 'calc(100vh - 57px)', paddingBottom: '50px', overflow: 'auto' }"
        :visible="visible"
        @close="handleDrawerClose"
    >
        <!-- 解决不置顶问题 -->
        <a-form :style="{ height: visible ? 'auto' : '0' }" class="session-form" :form="form">
            <a-row>
                <a-col>
                    <a-form-item>
                        <a-input style="width: 200px" v-decorator="['auther_name_tel']" :placeholder="$t('web.mobile_name' /* 手机号/姓名 */)"></a-input>
                        <a-input class="ml5 mr5" style="width: 200px" v-decorator="['auther_name_org']" :placeholder="$t('web.company' /* 单位 */)"></a-input>
                        <a-button type="primary">{{ $t('web.query' /* 查询 */) }}</a-button>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
        <!-- 表格 -->
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :sub-title="$t('program.tip' /* 如未查询到用户请点击右侧新增按钮 */)" :backIcon="false">
            <template slot="extra">
                <a-button type="primary">{{ $t('web.new' /* 新增 */) }}</a-button>
            </template>
        </a-page-header>
        <a-table
            ref="table"
            :rowKey="record => record.id"
            :columns="columns"
            :data-source="dataSource"
            :pagination="false"
            :scroll="{ x: 600 }"
            :row-selection="{
                selectedRowKeys: selectedRowKeys,
                onChange: onSelectChange,
                type: 'radio'
            }"
        ></a-table>
        <div
            class="t-r"
            :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                height: '50px',
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 99
            }"
        >
            <a-button type="default" @click="visible = false">{{ $t('web.cancel' /* 取消 */) }}</a-button>
            <a-button :loading="loading" :disabled="loading" class="ml10" type="primary" @click="handleSubmitEvent">{{ $t('web.ok' /* 确定 */) }}</a-button>
        </div>
    </a-drawer>
</template>

<script>
const dataSource = [
    { id: 11111, class_name: '测试' },
    { id: 22222, class_name: '测试2' },
    { id: 33333, class_name: '测试3' }
];
export default {
    name: 'AutherListDrawer',
    data() {
        return {
            visible: false,
            dataSource,
            selectedRowKeys: [],
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    align: 'left',
                    fixed: 'left',
                    width: 100
                },
                {
                    title: this.$t('web.name' /* 姓名 */),
                    dataIndex: 'class_name',
                    align: 'left',
                    width: 100
                },
                {
                    title: this.$t('web.mobile' /* 手机号 */),
                    dataIndex: 'phone',
                    align: 'left',
                    width: 120
                },
                {
                    title: this.$t('web.company' /* 单位 */),
                    dataIndex: 'org',
                    align: 'left'
                },
                {
                    title: this.$t('web.department' /* 科室 */),
                    dataIndex: 'real_name',
                    align: 'left',
                    width: 100
                }
            ],
            loading: false,
            form: this.$form.createForm(this)
        };
    },
    computed: {},
    methods: {
        show() {
            this.visible = true;
        },
        //关闭弹窗
        handleDrawerClose() {
            this.selectedRowKeys = [];
            this.visible = false;
        },
        // 单选框选中
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        handleSubmitEvent() {
            if (!this.selectedRowKeys.length) {
                this.$message.warning(this.$t('program.no_selected' /* 您还未选中作者 */));
                return false;
            }
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang='less' scoped>
::v-deep .ant-page-header-heading-sub-title {
    color: #333;
}
</style>